<div *ngIf="getIFrameURL()">
  <div class="header-section">
  <div>
    <div class="title">
      <div *ngIf="gocamDetailsList.length == 0">
        <span class="model-title-or-id">GO-CAM pathway model {{gocamIdParam}}</span>
      </div>
      <div *ngIf="gocamDetailsList.length == 1">
        GO-CAM pathway model
        <span class="model-title-or-id">
          <app-description-display [description]="gocamDetailsList[0].title" [descriptionParts]="titleParts[0] || []">
          </app-description-display>
        </span>
        <span *ngIf="sourcePageType != 'docs'">
          <span class="help-link"><a routerLink="/gocam">Main GO-CAM page</a></span>
        </span>
      </div>

      <div *ngIf="gocamDetailsList.length > 1" class="merged-model-list">
        <span *ngIf="overlappingGene">
          Merged GO-CAM pathway models with overlapping gene
          <app-gene-link [gene]="overlappingGene"></app-gene-link>:
        </span>
        <span *ngIf="!overlappingGene">Merged GO-CAM pathway models:</span>
         <div class="model-title-or-id" *ngFor="let detail of gocamDetailsList; let idx = index">
            <a *ngIf="source" routerLink="/gocam/pombase-view/docs/{{detail.gocam_id}}/{{source}}">{{detail.gocam_id}}</a>
            <a *ngIf="!source" routerLink="/gocam/pombase-view/docs/{{detail.gocam_id}}">{{detail.gocam_id}}</a>
            <app-description-display
             [description]="detail.title"
             [descriptionParts]="titleParts[idx]">
            </app-description-display>
         </div>
      </div>
    </div>

    <div class="return-to-gene-page" *ngIf="sourcePageType && sourcePageType != 'full'">
    <span *ngIf="sourcePageType == 'gene'">
      <a routerLink="/gene/{{source}}">Return to the {{sourceName || source}} gene page</a>
    </span>
    <span *ngIf="sourcePageType == 'term'">
      <a routerLink="/term/{{source}}">Return to the term page for {{sourceName}} ({{source}})</a>
    </span>
    <span *ngIf="sourcePageType == 'docs'">
      <a routerLink="/gocam">Return to the main GO-CAM page</a>
    </span>
    <span *ngIf="sourcePageType == 'subset-count'">
      <span class="highlighted-activities-desc"><span>Highlighted activities:</span> {{sourceName}}</span>
      <div *ngIf="isMegaModel" class="genes-in-gocams-link">
        <ul>
          <li><a (click)="gotoGenesInGoCamQuery('and')"
                 title='View genes from "{{sourceName || "query"}}" that are in one or more pathways'>
              Genes from list in a curated GO-CAM pathway ({{getGenesInGoCamsQueryCount('and') | async}})
          </a></li>
          <li><a (click)="gotoGenesInGoCamQuery('not')"
                 title='View genes from "{{sourceName || "query"}}" that are not yet included in a pathway'>
              Genes from list not yet in a curated GO-CAM pathway ({{getGenesInGoCamsQueryCount('not') | async}})
          </a>
          <div class="bp-slim-query">
            alternatively:
            <a (click)="gotoBPSlimGenesNotInPathway()">
              classify this list with the "Biological process slim"
            </a>
          </div>
        </li>
        </ul>

      </div>
    </span>
    </div>

    <div class="external-gocam-link" *ngIf="devMode() && !isMergedModel()">
      <a href="{{noctuaLink}}">View in Noctua</a>
    </div>

    <div class="external-gocam-link" *ngIf="devMode() && !isMergedModel()">
      <a href="{{amigoLink}}">View in AmiGO</a>
    </div>

    <div class="filter-group" *ngIf="isPomBaseView">
      <ng-container *ngIf="!paramFlags.includes('retain_genes')">

      <div class="filter-select">
        <input id="show-chemicals" type="checkbox"
               title="{{showChemicalsEnabled ? 'Show or hide chemicals' : 'No chemicals in this pathway'}}"
               [disabled]="!showChemicalsEnabled" [(ngModel)]="showChemicals"
               (ngModelChange)="updateUrl()">
        <label title="{{showChemicalsEnabled ? 'Show or hide chemicals' : 'No chemicals in this pathway'}}"

               for="show-chemicals">Show chemicals</label>
      </div>

      <div class="filter-select">
        <input id="show-all-inputs" type="checkbox"
               title="{{showTargetsEnabled ? 'Show or hide targets' : 'No targets in this pathway'}}"
               [disabled]="!showTargetsEnabled" [(ngModel)]="showTargets" (ngModelChange)="updateUrl()">
        <label title="{{showTargetsEnabled ? 'Show or hide targets' : 'No targets in this pathway'}}"
               for="show-all-inputs">Show target genes/complexes</label>
      </div>
      </ng-container>

      <div class="fitler-toggle" *ngIf="isMergedModel()">
        <input id="show-models-boxes" type="checkbox" [(ngModel)]="showModelBoxes" value="true" (ngModelChange)="updateUrl()">
        <label for="show-models-boxes">Show model boundaries</label>
      </div>

      <div class="algorithm-select" *ngIf="devMode() && isMergedModel()">
          <input id="merge-by-chemical" type="checkbox" [(ngModel)]="mergeByChemical" (ngModelChange)="updateUrl()">
          <label for="merge-by-chemical">Merge by chemical</label>
      </div>
    </div>
  </div>

  <div *ngIf="contributorNames" class="attribution">
    Curated by: {{contributorNames}}
  </div>
  <div *ngFor="let reviewer of reviewers" class="attribution">
<!--    Reviewed by: <a href="https://orcid.org/{{reviewer.orcid}}">{{reviewer.name}}</a>-->
    Reviewed by: {{reviewer.name}}
  </div>
  </div>

  <div class="iframe-container">
    <div *ngIf="modelGenes.length > 0" class="genes-and-terms">
      <div>
        <span title="Genes that enable activities in this pathway">
          Pathway genes:
        </span>
        <div class="gene-list-query-link">
          <a routerLink="{{makeGenesUrl()}}">(Send list to the Advanced Search)</a>
        </div>
        <ul>
          <li *ngFor="let geneSumm of modelGenes">
            <span [ngClass]="{'highlighted-gene': sourceGenes.has(geneSumm.uniquename)}">
            <app-gene-link [gene]="geneSumm" [long]="false"></app-gene-link>
            </span>
          </li>
        </ul>
      </div>
      <div *ngIf="targetGenes.length > 0">
        <span title="">Target genes</span>
        <div class="gene-list-query-link">
          <a routerLink="{{makeTargetsUrl()}}">(Send list to the Advanced Search)</a>
        </div>
        <ul>
          <li *ngFor="let geneSumm of targetGenes">
            <span [ngClass]="{'highlighted-gene': sourceGenes.has(geneSumm.uniquename)}">
            <app-gene-link [gene]="geneSumm" [long]="false"></app-gene-link>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="go-cam-iframe">
      <iframe [src]="getIFrameURL()" class="full-go-cam-view" #gocamiframe>
      </iframe>
    </div>
  </div>
</div>

